import { en } from './en'
import { es } from './es'
import {fa} from './fa'
export const messages = {
  en,
  es,
  fa
}
